import React, { ReactNode, useEffect, useState } from "react";
import { AlertMessageContainer, ContainerDetal, ProductPriceContainer, ProductTitleContainer } from "./styles";
import { useTranslation } from "../../../../hooks/useTranslation";
import { StoreState } from "../../../../store/createStore";
import { useSelector } from "react-redux";
import { RoundHelper } from "../../../../utils/roundHelper";

// Função para formatar a unidade baseada na quantidade
function formatUnit(qty: number, un: string | undefined): string {
    if (un?.toUpperCase() === 'KG') {
        if (qty >= 1) {
            return `${qty}kg`;
        } else {
            return `${(qty * 1000).toFixed(0)}g`;
        }
    } else {
        return `${qty.toFixed(0)} ${(un || 'un').toLowerCase()}`;
    }
}

// Função para padronizar a unidade de referência
function formatReferenceUnit(un: string | undefined): string {
    if (un?.toUpperCase() === 'KG') {
        return 'kg';
    } else {
        return (un || 'un').toLowerCase();
    }
} function ProductTitle({ title }: {
    title: string;
}) {
    return (
        <ProductTitleContainer>
            <span id="product-title-checkout">{title}</span>
        </ProductTitleContainer>
    );
}


function ProductPrice({ price, product, quantity }: {
    price: string;
    product: any;
    quantity: number;
}) {
    const dynamicPrice = Number(price);
    const referencePrice = Number(product.price || 0);
    return (
        <ProductPriceContainer>
                    <div className="dynamic-price">
                        {RoundHelper.toFormatted(dynamicPrice)}<span className="unit">/{formatUnit(quantity, product.un)}</span>
                    </div>
                    <div className="reference-price">
                        {RoundHelper.toFormatted(referencePrice)}/{formatReferenceUnit(product.un)}
                    </div>
        </ProductPriceContainer>
    );
}

function ProductWarranty({ productId }: { productId: string }) {
    const { onTranslation: t } = useTranslation();
    const { checkout } = useSelector((state: StoreState) => state.checkout);
    const [hasWarrantySelected, setHasWarrantySelected] = useState('');

    useEffect(() => {
        if (checkout.services) {
            checkout.services.forEach(service => {
                if (productId === service.product_id) {
                    // Compare with product.id
                    setHasWarrantySelected(
                        `${t(
                            'main.new_checkout.nchk_products_list.product_view_list.warranty_selected',
                        )} 
               ${service.service.service_period} 
               ${t('main.new_checkout.nchk_products_list.product_view_list.month')} 
               ${RoundHelper.toFormatted(service.service.service_price)}`);
                }
            });
        }
    }, [checkout.services, productId, t]);

    return (
        <ProductTitleContainer>
            {hasWarrantySelected !== '' && <span>{hasWarrantySelected}</span>}
        </ProductTitleContainer>
    );
}


function ProductDetailRoot({ children }: {
    children: ReactNode
}) {
    return (
        <ContainerDetal>
            {children}
        </ContainerDetal>
    )
}

function AlertMessage({ message }: { message: string }) {
    return (
        <AlertMessageContainer>
            <span>{message}</span>
        </AlertMessageContainer>
    )
}

export const ProductDetail = {
    Root: ProductDetailRoot,
    Title: ProductTitle,
    Price: ProductPrice,
    Warranty: ProductWarranty,
    Alert: AlertMessage,
}